module.exports = __webpack_public_path__ + "img/twikey.8978b96b.svg";